import React from "react";
import { Factory, BadgeCheck, Building2, FileCheck2, Container, LayoutGrid } from "lucide-react";
import { Reveal, Overline, Stagger, StaggerItem } from "./primitives";

const features = [
  {
    icon: Factory,
    title: "Factory Direct Purchasing",
    desc: "Buy full containers straight from the source. No intermediaries, no product markups, no middle layers between you and the manufacturer.",
  },
  {
    icon: BadgeCheck,
    title: "Verified Manufacturers",
    desc: "Every Turkish manufacturer is vetted and verified, so you source from suppliers you can trust with confidence.",
  },
  {
    icon: Building2,
    title: "One Supplier",
    desc: "Purchase an entire container from a single manufacturer you already know — clean, direct and simple.",
  },
  {
    icon: FileCheck2,
    title: "One Purchase Order",
    desc: "A single confirmed purchase order governs the whole operation, from production through delivery.",
  },
  {
    icon: Container,
    title: "One Container",
    desc: "Full container quantities designed for buyers who know exactly what they need and how much.",
  },
  {
    icon: LayoutGrid,
    title: "One Workspace",
    desc: "Quotations, production, inspection, freight and shipment — all coordinated inside one connected Workspace.",
  },
];

export const FeaturesSection = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="border-t border-slate-100 bg-slate-50/40 py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <Overline>Why FullContainer™</Overline>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-ink md:text-4xl">
            Built for factory-direct full container procurement.
          </h2>
          <p className="mt-4 text-base text-slateink md:text-lg">
            The simplest, most professional way to purchase an entire container from a single
            verified manufacturer.
          </p>
        </Reveal>

        <Stagger className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <StaggerItem key={f.title}>
              <div
                data-testid={`feature-card-${f.title.toLowerCase().replace(/\s/g, "-")}`}
                className="group h-full rounded-2xl border border-slate-200 bg-white p-7 shadow-card-base transition-all duration-300 hover:-translate-y-1 hover:border-demax/30 hover:shadow-card-hover"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-demax-soft text-demax transition-colors group-hover:bg-demax group-hover:text-white">
                  <f.icon className="h-5 w-5" strokeWidth={1.75} />
                </span>
                <h3 className="mt-5 font-display text-lg font-semibold tracking-tight text-ink">
                  {f.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slateink">{f.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
